<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.configuration.shared.printing-pattern.dialog.title' | translate"
		id="printing-pattern-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			@if (viewModel.isFormReady) {
				<div class="grid" [sklValidationSource]="viewValidation">
					<div class="col-1">
						<div class="col-1-3">
							<ins-form-field
								[label]="'scenes.configuration.shared.printing-pattern.dialog.form.pattern-type.label' | translate">
								<ins-select
									id="printing-pattern-dialog-kind"
									display-text="label"
									[converter]="viewModel.printingPatternTypeValueConverter"
									[(ngModel)]="viewModel.bo.model.kind"
									(ngModelChange)="viewModel.onPatternTypeChange($event)"
									[sklValidate]="getValidationKey('kind')">
									@for (item of viewModel.printingPatternTypes; track item) {
										<ins-option
											[value]="item">
											{{item.label}}
										</ins-option>
									}
								</ins-select>
							</ins-form-field>
						</div>
						<div class="col-1-3">
							<ins-form-field
								[label]="'scenes.configuration.shared.printing-pattern.dialog.form.name.label' | translate">
								<ins-input
									[skl-focus-by]
									[(ngModel)]="viewModel.bo.model.name"
									id="printing-pattern-dialog-name"
									[placeholder]="'scenes.configuration.shared.printing-pattern.dialog.form.name.placeholder' | translate"
									[sklValidate]="getValidationKey('name')">
								</ins-input>
							</ins-form-field>
						</div>
						<div class="col-1-3">
							<ins-form-field
								[label]="'scenes.configuration.shared.printing-pattern.dialog.form.secondary-language.label' | translate">
								<ins-select
									display-text="label"
									[converter]="viewModel.secondaryLanguageValueConverter"
									id="printing-pattern-dialog-secondary-language"
									[(ngModel)]="viewModel.bo.model.secondaryLanguage"
									[placeholder]="'ui.placeholders.empty' | translate"
									[sklValidate]="getValidationKey('secondaryLanguage')">
									<ins-option
										[value]="null">
										{{'ui.placeholders.empty' | translate}}
									</ins-option>
									@for (item of viewModel.secondaryLanguages; track item) {
										<ins-option
											[value]="item">
											{{item.label}}
										</ins-option>
									}
								</ins-select>
							</ins-form-field>
						</div>
						<div class="col-1">
							@if (!viewModel.isAdvancePattern()) {
								<div class="col-1-3">
									<ins-form-field
										[label]="'scenes.configuration.shared.printing-pattern.dialog.form.document-title.label' | translate">
										<ins-input
											[(ngModel)]="viewModel.bo.model.documentTitle"
											id="printing-pattern-dialog-document-title"
											[placeholder]="'scenes.configuration.shared.printing-pattern.dialog.form.document-title.placeholder' | translate"
											[sklValidate]="getValidationKey('documentTitle')">
										</ins-input>
									</ins-form-field>
								</div>
							} @else {
								<div class="col-1-3">
									<ins-form-field
										[label]="'scenes.configuration.shared.printing-pattern.dialog.form.document-title-advance.label' | translate">
										<ins-input
											[(ngModel)]="viewModel.bo.model.documentTitle"
											id="printing-pattern-dialog-advance-document-title"
											[placeholder]="'scenes.configuration.shared.printing-pattern.dialog.form.document-title-advance.placeholder' | translate"
											[sklValidate]="getValidationKey('documentTitle')">
										</ins-input>
									</ins-form-field>
								</div>
								<div class="col-1-3">
									<ins-form-field
										[label]="'scenes.configuration.shared.printing-pattern.dialog.form.document-title-advance-final.label' | translate">
										<ins-input
											[(ngModel)]="viewModel.bo.model.finalAdvanceDocumentTitle"
											id="printing-pattern-dialog-final-advance-document-title"
											[placeholder]="'scenes.configuration.shared.printing-pattern.dialog.form.document-title-advance-final.placeholder' | translate"
											[sklValidate]="getValidationKey('finalAdvanceDocumentTitle')">
										</ins-input>
									</ins-form-field>
								</div>
							}
							<div class="align--big-top col-1-3">
								<ins-checkbox
									class="col-1-2 align--checkbox"
									id="printing-pattern-dialog-disable-shadows"
									[ngClass]="{'display--none':!viewModel.showParameter('disableShadows')}"
									[(ngModel)]="viewModel.bo.model.disableShadows"
									[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.disable-shadows' | translate"
									[sklValidate]="getValidationKey('disableShadows', viewModel.bo.model.sun)">
								</ins-checkbox>
							</div>
						</div>
						<div class="col-1">
							<div class="col-2-3">
								<div class="align--form">
									<span class="text--group-label text--info">
										{{'scenes.configuration.shared.printing-pattern.dialog.form.column-setting.label' | translate}}
									</span>
								</div>
								<skl-grid-ins
									id="printing-pattern-dialog-parameters-grid"
									[dataSource]="viewModel.gridDataSource$"
									[columns]="viewModel.gridColumns$"
									[options]="viewModel.gridOptions">
									<ng-template [sklGridTemplate]="'printingPatternGridWithCell'" let-row="row" let-col="col">
										<skl-printing-pattern-dialog-grid-width
											[entity]="row">
										</skl-printing-pattern-dialog-grid-width>
									</ng-template>
									<ng-template [sklGridTemplate]="'gridMoveRowCell'" let-row="row" let-col="col">
										<skl-grid-move-row-cell
											[entity]="row"
											[items]='viewModel.gridDataSource$.value'
											(onMove)="swapPrintingPatternColumn($event, row)">
										</skl-grid-move-row-cell>
									</ng-template>
								</skl-grid-ins>
								<div class="align--grid-cell">
									<div
										class="col-1-2"
										[ngClass]="{ 'display--none': viewModel.availablePrintingPatternColumnsCollection.length === 0 }">
										<ins-form-field class="no-boundary">
											<ins-select
												(insertion)="viewModel.onAdd($event)"
												id="printing-pattern-dialog-available-printing-parameters"
												display-text="name"
												[placeholder]="'scenes.configuration.shared.printing-pattern.dialog.grid.insertion.placeholder' | translate">
												@for (item of viewModel.availablePrintingPatternColumnsCollection; track item) {
													<ins-option
														[value]="item">
														{{ item.name }}
													</ins-option>
												}
											</ins-select>
										</ins-form-field>
									</div>
								</div>
							</div>
							<div class="col-1-3">
								<div class="align--medium-left">
									<div class="align--form-top align--form-bottom align--form-left">
										<span class="text--group-label text--info">
											{{'scenes.configuration.shared.printing-pattern.dialog.form.print.label' | translate}}
										</span>
									</div>
									<div class="col-1">
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-logo"
											[ngClass]="{'display--none':!viewModel.showParameter('logo')}"
											[(ngModel)]="viewModel.bo.model.includes.logo"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.logo' | translate"
											[sklValidate]="getValidationKey('logo', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-document-note"
											[ngClass]="{'display--none':!viewModel.showParameter('documentNote')}"
											[(ngModel)]="viewModel.bo.model.includes.documentNote"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.document-note' | translate"
											[sklValidate]="getValidationKey('documentNote', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-item-note"
											[ngClass]="{'display--none':!viewModel.showParameter('itemNote')}"
											[(ngModel)]="viewModel.bo.model.includes.itemNote"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.document-position-note' | translate"
											[sklValidate]="getValidationKey('itemNote', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-product-note"
											[ngClass]="{'display--none':!viewModel.showParameter('productNote')}"
											[(ngModel)]="viewModel.bo.model.includes.productNote"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.product-note' | translate"
											[sklValidate]="getValidationKey('productNote', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-related-client-tin"
											[ngClass]="{'display--none':!viewModel.showParameter('relatedClientTIN')}"
											[(ngModel)]="viewModel.bo.model.includes.relatedClientTIN"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.recipient-exhibitor-nip' | translate"
											[sklValidate]="getValidationKey('relatedClientTIN', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-delivery-address"
											[ngClass]="{'display--none':!viewModel.showParameter('deliveryAddress')}"
											[(ngModel)]="viewModel.bo.model.includes.deliveryAddress"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.other-address' | translate"
											[sklValidate]="getValidationKey('deliveryAddress', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-exchange-rate"
											[ngClass]="{'display--none':!viewModel.showParameter('exchangeRate')}"
											[(ngModel)]="viewModel.bo.model.includes.exchangeRate"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.exchange-rate' | translate"
											[sklValidate]="getValidationKey('exchangeRate', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-base-currency-document-gross"
											[(ngModel)]="viewModel.bo.model.includes.baseCurrencyDocumentGross"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.show-base-currency-values' | translate"
											[sklValidate]="getValidationKey('baseCurrencyDocumentGross', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-left-to-pay"
											[ngClass]="{'display--none':!viewModel.showParameter('leftToPay')}"
											[(ngModel)]="viewModel.bo.model.includes.leftToPay"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.left-to-pay' | translate"
											[sklValidate]="getValidationKey('leftToPay', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-base-currency-vat-table"
											[ngClass]="{'display--none':!viewModel.showParameter('baseCurrencyVatTable')}"
											[(ngModel)]="viewModel.bo.model.includes.baseCurrencyVatTable"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.vat-table-in-base-currency' | translate"
											[sklValidate]="getValidationKey('baseCurrencyVatTable', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-vat-table"
											[ngClass]="{'display--none':!viewModel.showParameter('vatTable')}"
											[(ngModel)]="viewModel.bo.model.includes.vatTable"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.vat-table' | translate"
											[sklValidate]="getValidationKey('vatTable', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-vat-table-when-reverse-charge"
											[ngClass]="{'display--none':!viewModel.showParameter('vatTableWhenReverseCharge')}"
											[(ngModel)]="viewModel.bo.model.includes.vatTableWhenReverseCharge"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.vat-table-when-reverse-charge' | translate"
											[sklValidate]="getValidationKey('vatTableWhenReverseCharge', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-issuer"
											[ngClass]="{'display--none':!viewModel.showParameter('issuer')}"
											[(ngModel)]="viewModel.bo.model.includes.issuer"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.exhibitor' | translate"
											[sklValidate]="getValidationKey('issuer', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-recipient"
											[ngClass]="{'display--none':!viewModel.showParameter('recipient')}"
											[(ngModel)]="viewModel.bo.model.includes.recipient"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.recipient' | translate"
											[sklValidate]="getValidationKey('recipient', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-source-document-info"
											[ngClass]="{'display--none':!viewModel.showParameter('sourceDocumentInfo')}"
											[(ngModel)]="viewModel.bo.model.includes.sourceDocumentInfo"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.source-document-info' | translate"
											[sklValidate]="getValidationKey('sourceDocumentInfo', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-explain-sale-date"
											[ngClass]="{'display--none':!viewModel.showParameter('explainSaleDate')}"
											[(ngModel)]="viewModel.bo.model.includes.explainSaleDate"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.explain-sale-date' | translate"
											[sklValidate]="getValidationKey('explainSaleDate', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-jpk-codes"
											[ngClass]="{'display--none':!viewModel.showParameter('jpkCodes')}"
											[(ngModel)]="viewModel.bo.model.includes.jpkCodes"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.jpk-codes' | translate"
											[sklValidate]="getValidationKey('jpkCodes', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-unsettled-documents"
											[ngClass]="{'display--none':!viewModel.showParameter('unsettledDocuments')}"
											[(ngModel)]="viewModel.bo.model.includes.unsettledDocuments"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.unsettled-documents' | translate"
											[sklValidate]="getValidationKey('unsettledDocuments', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-previous-advances-list"
											[ngClass]="{'display--none':!viewModel.showParameter('previousAdvancesList')}"
											[(ngModel)]="viewModel.bo.model.includes.previousAdvancesList"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.previous-advances-list' | translate"
											[sklValidate]="getValidationKey('previousAdvancesList', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-payments"
											[ngClass]="{'display--none':!viewModel.showParameter('payments')}"
											[(ngModel)]="viewModel.bo.model.includes.payments"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.payments' | translate"
											[sklValidate]="getValidationKey('payments', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-ksef-number"
											[ngClass]="{'display--none':!viewModel.showParameter('ksefNumber')}"
											[(ngModel)]="viewModel.bo.model.includes.ksefNumber"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.ksef-number' | translate"
											[sklValidate]="getValidationKey('ksefNumber', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
										<ins-checkbox
											class="col-1 align--medium-bottom"
											id="printing-pattern-dialog-includes-summary"
											[ngClass]="{'display--none':!viewModel.showParameter('summary')}"
											[(ngModel)]="viewModel.bo.model.includes.summary"
											[label]="'scenes.configuration.shared.printing-pattern.dialog.form.print.summary' | translate"
											[sklValidate]="getValidationKey('summary', viewModel.bo.model.includes.sun)">
										</ins-checkbox>
									</div>
								</div>
							</div>
						</div>
						<div class="col-1">
							<div class="col-1">
								<ins-form-field
									[label]="'scenes.configuration.shared.printing-pattern.dialog.form.additional-company-data.label' | translate">
									<ins-textarea
										rows="3"
										id="printing-pattern-dialog-my-company-note"
										[(ngModel)]="viewModel.bo.model.myCompanyNote"
										[placeholder]=" 'scenes.configuration.shared.printing-pattern.dialog.form.additional-company-data.placeholder' | translate "
										[sklValidate]="getValidationKey('myCompanyNote')">
									</ins-textarea>
								</ins-form-field>
							</div>
						</div>
						<div class="col-1">
							<ins-form-field
								[label]=" 'scenes.configuration.shared.printing-pattern.dialog.form.const-note-on-print.label' | translate ">
								<ins-textarea
									rows="3"
									[(ngModel)]="viewModel.bo.model.note"
									id="printing-pattern-dialog-note"
									[placeholder]=" 'scenes.configuration.shared.printing-pattern.dialog.form.const-note-on-print.placeholder' | translate "
									[sklValidate]="getValidationKey('note')">
								</ins-textarea>
							</ins-form-field>
						</div>
					</div>
				</div>
			}
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="printing-pattern-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			typeName="accent"
			[spinner]="viewModel.isSaving"
			id="printing-pattern-dialog-save-button"
			(click)="onConfirmAsync()">
			{{ 'scenes.configuration.shared.base.dialog.buttons.save' | translate }}
		</skl-button>
	</ins-footer>

</skl-dialog-content-ins>